import {BusinessProcessDimension} from './businessProcessDimension.model';
import {StateDimension} from './stateDimension.model';

export class PanelConfigurationIndicators {

  businessProcessDimension: BusinessProcessDimension;
  stateDimension: StateDimension;
  id: number;
  to: Date;
  ta: Date;
  te: Date;
  fomatedTA: string;
  fomatedTE: string;
  fomatedTO: string;
  sla: number;
  toleranceInterval: number;

  constructor () {
    this.businessProcessDimension = new BusinessProcessDimension();
    this.stateDimension = new StateDimension();
  }

}
